import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/common/ScrollToTop";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
//import Register from "./pages/Register";
import Rules from "./pages/Rules";
import Prizes from "./pages/Prizes";
import Contact from "./pages/Contact";
import Exe2025 from "./pages/Exe2025";
import Submissions from "./pages/Submissions";
import LocalBusinessSchema from "./components/common/LocalBusinessSchema";
import { Helmet, HelmetProvider } from "react-helmet-async";

const App = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "EXE - Game Development Competition",
    alternateName: "EXE Competition",
    description:
      "Sri Lanka's flagship game development competition attracting developers and industry partners to create innovative games",
    url: "https://exe.levelstair",
    logo: {
      "@type": "ImageObject",
      url: "https://exe.levelstair/ExeLogo.png",
      width: "512",
      height: "512",
      alternateName: "EXE Competition Logo",
    },
    image: "https://exe.levelstair/ShareImage.png",
    foundingDate: "2025",
    foundingLocation: {
      "@type": "Place",
      name: "Colombo, Sri Lanka",
    },
    areaServed: {
      "@type": "Country",
      name: "Sri Lanka",
    },
    audience: {
      "@type": "Audience",
      audienceType: "Game Developers, Students, Industry Professionals",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+94-11-123-4567",
      contactType: "customer service",
      email: "exe@levelstair.com",
    },
    sameAs: [
      "https://discord.gg/exe",
      "https://twitter.com/exe_competition",
      "https://linkedin.com/company/exe-competition",
    ],
    knowsAbout: [
      "Game Development",
      "Unity",
      "Unreal Engine",
      "Godot",
      "Game Programming",
      "Game Design",
      "Indie Games",
      "VFX",
      "Sound Design",
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "250",
    },
  };

  return (
    <HelmetProvider>
      <Router>
        <div className="app bg-exe-bg-primary min-h-screen">
          <Helmet>
            <title>EXE - Sri Lanka's Flagship Game Development Competition</title>
            <meta
              name="description"
              content="Join EXE, Sri Lanka's premier game development competition. Connect with industry professionals, compete for amazing prizes, and showcase your game development skills."
            />
            <meta
              name="keywords"
              content="game development, competition, Sri Lanka, Unity, Unreal Engine, indie games, gaming, developers, prizes, industry"
            />
            <meta name="author" content="EXE Competition Team" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="en" />
            <meta name="theme-color" content="#00ff41" />
            
            {/* Open Graph Tags */}
            <meta property="og:title" content="EXE - Sri Lanka's Flagship Game Development Competition" />
            <meta property="og:description" content="Join EXE, Sri Lanka's premier game development competition. Connect with industry professionals, compete for amazing prizes, and showcase your game development skills." />
            <meta property="og:image" content="https://exe.levelstair/ShareImage.png" />
            <meta property="og:url" content="https://exe.levelstair" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="EXE Competition" />
            
            {/* Twitter Card Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="EXE - Sri Lanka's Flagship Game Development Competition" />
            <meta name="twitter:description" content="Join EXE, Sri Lanka's premier game development competition. Connect with industry professionals, compete for amazing prizes, and showcase your game development skills." />
            <meta name="twitter:image" content="https://exe.levelstair/ShareImage.png" />
            
            {/* Additional SEO */}
            <link rel="canonical" href="https://exe.levelstair" />
            <meta name="google-site-verification" content="your-google-verification-code" />
          </Helmet>

          <LocalBusinessSchema data={schemaData} />
          <ScrollToTop />
          
          <div className="flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                {/* <Route path="/register" element={<Register />} /> */}
                <Route path="/rules" element={<Rules />} />
                <Route path="/prizes" element={<Prizes />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/exe2025" element={<Exe2025 />} />
                <Route path="/submissions" element={<Submissions />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
